import { render, staticRenderFns } from "./service-for.vue?vue&type=template&id=7d84a5c1&scoped=true"
import script from "./service-for.vue?vue&type=script&lang=js"
export * from "./service-for.vue?vue&type=script&lang=js"
import style0 from "./service-for.vue?vue&type=style&index=0&id=7d84a5c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d84a5c1",
  null
  
)

export default component.exports